import React from 'react';
import ToolbarSmallButton from './ToolbarSmallButton';
import ToolbarSeparator from './ToolbarSeparator';
import ToolbarExpand from './ToolbarExpand';

function ToolbarButtons(_ref) {
  var editor = _ref.editor,
      buttons = _ref.buttons,
      isInsertion = _ref.isInsertion,
      isMinimal = _ref.isMinimal,
      onRendered = _ref.onRendered;
  React.useLayoutEffect(function () {
    return onRendered();
  });
  return React.createElement("div", {
    className: "padding-smaller flexbox flexbox-align-center"
  }, buttons.map(function (button) {
    return React.createElement(ToolbarSmallButton, {
      key: button.id,
      editor: editor,
      button: button,
      isInsertion: isInsertion,
      dimmed: isMinimal
    });
  }), React.createElement(ToolbarSeparator, null), React.createElement(ToolbarExpand, {
    editor: editor,
    dimmed: isMinimal
  }));
}

export default React.memo(ToolbarButtons);